import { takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from '@layout/services/layout/layout.service';
import { PushNotificationsService } from '@shared/services/push-notifications/push-notifications.service';

import { MobileFooterComponent } from '../mobile-footer/mobile-footer.component';
import { MobileHeaderComponent } from '../mobile-header/mobile-header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
	selector: 'app-app-layout',
	imports: [RouterOutlet, CommonModule, SidebarComponent, MobileHeaderComponent, MobileFooterComponent],
	templateUrl: './app-layout.component.html',
	styleUrl: './app-layout.component.scss',
})
export class AppLayoutComponent implements OnInit, OnDestroy {
	private layoutService = inject(LayoutService);
	private pushNotificationService = inject(PushNotificationsService);

	destroyed$ = new EventEmitter<void>();
	isMobileSize = true;

	ngOnInit(): void {
		this.layoutService.isMobileSize$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
			this.isMobileSize = value;
		});

		this.pushNotificationService.init();
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}
}
